import React from 'react';
import {
  Box, Container, Typography, Grid, Stack, Card, CardContent, Rating, Avatar,
} from '@mui/material';
import { Star } from '@mui/icons-material';
import { C, Section, SectionLabel } from './theme';

const reviews = [
  {
    name: 'Rohit M.', title: 'Rankings moved within 3 weeks',
    body: 'We ordered the Growth Tier package for a client site and started seeing keyword movement within three weeks. The report showed every single live URL — no guesswork at all.',
    date: '2 weeks ago',
  },
  {
    name: 'Ayesha K.', title: 'Finally, links that don\u2019t feel spammy',
    body: 'I\u2019ve bought backlinks from marketplaces before and always worried about penalties. This was the first time the sites actually looked and felt legitimate.',
    date: '1 month ago',
  },
  {
    name: 'Sandeep Agency', title: 'Now our go-to white-label partner',
    body: 'We manage SEO for a dozen clients and outsource all link building here. The reporting makes it easy to show our clients real proof of work.',
    date: '3 weeks ago',
  },
  {
    name: 'Meera S.', title: 'Support answered every question fast',
    body: 'Had a few questions about anchor text strategy before ordering and the team walked me through it clearly. Delivery was right on schedule too.',
    date: '1 week ago',
  },
  {
    name: 'Vikram T.', title: 'Authority Tier was worth every rupee',
    body: 'Went with the Authority Tier for a competitive niche. The guest posts alone were on sites I recognized — genuinely high quality placements.',
    date: '2 months ago',
  },
  {
    name: 'Divya R.', title: 'Simple checkout, no back-and-forth',
    body: 'Ordering was straightforward — picked a package, gave my target URL and keywords, and paid securely. Didn\u2019t have to re-enter my details at all.',
    date: '5 days ago',
  },
];

const VpsReviews = () => (
  <Section id="reviews" sx={{ background: C.bgSection, borderBottom: `1px solid ${C.border}` }}>
    <Container maxWidth="lg">

      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <SectionLabel>PROVEN TRUST</SectionLabel>
        <Typography variant="h2" sx={{
          fontWeight: 800, fontSize: { xs: '1.85rem', md: '2.5rem' },
          color: C.textPrimary, letterSpacing: '-0.03em', mb: 1.5,
        }}>
          Trusted by 500+ marketers and agencies
        </Typography>
        <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
          <Rating value={4.8} precision={0.5} readOnly sx={{ color: '#F59E0B' }} />
          <Typography sx={{ color: C.textPrimary, fontWeight: 700, fontSize: '0.95rem' }}>
            Excellent 4.8
          </Typography>
          <Typography sx={{ color: C.textMuted, fontSize: '0.95rem' }}>
            Based on client reviews
          </Typography>
        </Stack>
      </Box>

      {/* Reviews Grid (MUI v6 Grid size) */}
      <Grid container spacing={3}>
        {reviews.map((r) => (
          <Grid size={{ xs: 12, sm: 6, lg: 4 }} key={r.name}>
            <Card elevation={0} sx={{
              border: `1px solid ${C.border}`,
              borderRadius: '14px',
              p: 3,
              height: '100%',
              background: '#FFFFFF',
              display: 'flex', flexDirection: 'column',
              boxShadow: '0 2px 10px rgba(0,0,0,0.03)',
            }}>
              <Rating value={5} readOnly size="small" sx={{ color: '#F59E0B', mb: 1.5 }} />
              <Typography sx={{ color: C.textPrimary, fontWeight: 700, fontSize: '0.95rem', mb: 1 }}>
                {r.title}
              </Typography>
              <Typography sx={{ color: C.textSecondary, fontSize: '0.84rem', lineHeight: 1.6, flex: 1, mb: 2.5 }}>
                {r.body}
              </Typography>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Avatar sx={{ width: 32, height: 32, background: C.primary, fontSize: '0.8rem', fontWeight: 700 }}>
                  {r.name[0]}
                </Avatar>
                <Box>
                  <Typography sx={{ color: C.textPrimary, fontWeight: 700, fontSize: '0.82rem' }}>
                    {r.name}
                  </Typography>
                  <Typography sx={{ color: C.textMuted, fontSize: '0.74rem' }}>
                    {r.date}
                  </Typography>
                </Box>
              </Stack>
            </Card>
          </Grid>
        ))}
      </Grid>

    </Container>
  </Section>
);

export default VpsReviews;
